import {BaseClient} from '../utils/base-client';

class AvatarsClient extends BaseClient {
  buildEndpoint() {
    const baseUrl = `api/app/avatars/`;
    return `${baseUrl}`;
  }
  buildQueryParams(params) {
    if (params.projectId) {
      return {project_id: params.projectId};
    } else {
      return {organization_id: params.organizationId};
    }
  }

  processResponse(response, _params) {
    return response.results;
  }
}

export const avatarsClient = new AvatarsClient();
